import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'rentware-cart-header',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareCartHeader {
  @Prop() headerTitle: string = 'Booking';
  @Prop() onClose;
  @Prop() showTimer: boolean = true;

  render() {
    return (
      <div class="HeaderContainer">
        <p class="HeaderTitle">{this.headerTitle}</p>

        <div class="RightContainer">
          {this.showTimer && (
            <span class="ExpirationContainer">
              <rentware-expiration-timer />
            </span>
          )}

          {this.onClose && <rtr-close-button onClose={this.onClose} />}
        </div>
      </div>
    );
  }
}
